import Link from 'next/link';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Category } from '@/api/games';
import { GamesGrid } from '@/components/GamesGrid';
import type { ISearchFallbackScenariosProps } from '..';
import { THEME_SCENARIO_ID } from '../helpers';
import { ScSearchFallbackScenario } from '../styled';

type ThemeScenarioProps = ISearchFallbackScenariosProps;

export const ThemeScenario: React.FC<ThemeScenarioProps> = ({
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href={`/games/${THEME_SCENARIO_ID}#gamesSection`}
                  onClick={closeModal}
                />
              ),
            }}
            i18nKey="searchFallback.subtitle.theme"
            ns="lobby"
          />
        </p>
      </div>
      <GamesGrid
        category={Category.MIGHTY_MAGIC}
        {...gridOptions}
        onDemoClick={(game) =>
          handleSearchGameClick(game, 'custom_mighty_magic')
        }
        onPlayClick={(game) =>
          handleSearchGameClick(game, 'custom_mighty_magic')
        }
      />
    </ScSearchFallbackScenario>
  );
};
